import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ROOT_URL from "../../Utilities/apiconfig";

const Contacts = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${ROOT_URL}/api/contacts/add`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        location: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const faqs = [
   
    {
        question: "What makes Columbiaa Multi Specialty Hospital unique?",
        answer: "Columbiaa Multi Specialty Hospital offers a blend of advanced medical technology, compassionate care, and a patient-centered approach, providing comprehensive healthcare across a wide range of Specialities, from cardiology to neurology, and critical care to plastic surgery."
    },
    {
        question: "How can I book an appointment?",
        answer: "Booking an appointment is easy. Simply call our helpline at 080 4448 4444, 080 4093 9899, or +91 85489 79899, or visit our hospital at Building No 06, 5th Main Rd, B Channasandra, OMBR Layout, Kasturi Nagar, Bengaluru, Karnataka 560043. You can also book appointments through our website"
    },
    {
        question: "What specialities does Columbiaa Hospital offer?",
        answer: "We provide expert care in over 20 medical specialities, including General Surgery, Orthopedics, Cardiology, Neurology, Oncology, Urology, Diabetology, Endocrinology, and more, ensuring comprehensive treatment for every patient."
    },
    {
        question: "Do you provide emergency services?",
        answer: "Yes, our Emergency Department operates 24/7, equipped with advanced life-saving equipment and highly trained medical professionals to handle critical situations."
    },
    {
        question: "What support is available for family members of patients?",
        answer: "We provide comfortable in-room accommodations for one attendant, regular health updates, and personalized support to ensure a smooth experience for families during treatment."
    },
    {
      question: "What services are available for international patients?",
      answer: "Columbiaa Hospital offers comprehensive healthcare services for international patients, including surgical packages, visa-related support, language interpreters, and personalized care plans. For appointments, you can reach us at 080 4448 4444, 080 4093 9899, or +91 85489 79899. For Neuroscience appointments, contact via WhatsApp at +91 99025 86436. For surgical packages, visa letters, and appointment assistance, connect with our Manager on Duty (MOD) at +91 85489 79899. Visit our website for the latest updates."
  },
    {
        question: "How do you ensure patient safety and privacy?",
        answer: "We prioritize patient safety and confidentiality, adhering to strict medical protocols, advanced infection control measures, and secure data management practices."
    },
    {
        question: "Do you offer rehabilitation and physiotherapy services?",
        answer: "Yes, our physiotherapy and rehabilitation department provides personalized recovery plans, including post-surgery therapy, pain management, and mobility enhancement."
    },
    {
        question: "What technology and medical advancements are available at Columbiaa Hospital?",
        answer: "We utilize state-of-the-art medical technology for diagnosis, treatment, and surgery, including minimally invasive techniques and advanced imaging for precise care."
    },
    {
        question: "How can I stay connected with Columbiaa Hospital for regular health updates?",
        answer: "Stay connected through our website, social media channels, or reach out via care@columbiaahospital.com for the latest health tips, hospital updates, and patient stories."
    }
];


  return (
    <div>
      {/* Page Title */}
  
      <section
  className="page-title py-5"
  style={{
    backgroundImage: "url(assets/images/background/page-title-2.jpg)",
    overflowX: "hidden",
  }}
  aria-label="Contact Page Banner"
>
  <div
    className="pattern-layer"
    style={{
      backgroundImage: "url(assets/images/shape/pattern-35.png)",
    }}
  ></div>
  <div className="container">
    <div className="row justify-content-center">
      <div
        className="col-12 col-md-10 text-center"
        data-aos="fade-right"
      >
        <div className="title-box my-4 my-md-0">
          <h1 className="display-4">Get In Touch</h1>
          <p className="lead">Columbiaa Hospital – Your Health Care Partner in Kasturi Nagar, Bangalore.</p>        </div>
      </div>
    </div>
  </div>
</section>


      {/* Contact Info Section */}
      <section className="contactinfo-section contact-page-section">
        <div className="auto-container">
          <div className="row clearfix">
            <div
              className="col-lg-6 col-md-12 col-sm-12 content-column"
              data-aos="fade-right"
            >
              <div id="content_block_6">
                <div className="content-box">
                  <ul className="info-list clearfix mt-5">
                    <li>
                      <figure className="icon-box">
                        <img src="assets/images/icons/icon-39.png" alt="Location icon" />
                      </figure>
                      <div className="inner">
                        <h4>Location</h4>
                        <p>
                          Building No 06, 5th Main Rd, B Channasandra, OMBR Layout,
                          Kasturi Nagar, Bengaluru, Karnataka 560043
                        </p>
                      </div>
                    </li>
                    <li>
                      <figure className="icon-box">
                        <img src="assets/images/icons/icon-40.png" alt="Phone icon" />
                      </figure>
                      <div className="inner">
                        <h4>For Appointments</h4>
                        <p><a href="tel:08044484444">080 44484444</a></p>
                        <p><a href="tel:08040939899">080 40939899</a></p>
                        <p><a href="tel:8548979899">(+91) 8548979899</a></p>
                      </div>
                    </li>
                    <li>
                      <figure className="icon-box">
                        <img src="assets/images/icons/icon-41.png" alt="Clock icon" />
                      </figure>
                      <div className="inner">
                        <h4>Hospital Hours</h4>
                        <p>Open 24 hours</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 col-md-12 col-sm-12 form-column"
              data-aos="fade-left"
            >
              <div className="form-inner">
                <h2>What are you looking for?</h2>
                <form id="contact-form" className="default-form" onSubmit={handleSubmit}>
                  <div className="row clearfix">
                    {Object.keys(formData).map((key) => (
                      <div
                        key={key}
                        className={`${
                          key === "message" ? "col-12" : "col-lg-6 col-md-6 col-sm-12"
                        } form-group`}
                      >
                        {key !== "message" ? (
                          <input
                            type={key === "email" ? "email" : "text"}
                            name={key}
                            placeholder={`${key.charAt(0).toUpperCase() + key.slice(1)} *`}
                            value={formData[key]}
                            onChange={handleChange}
                            required
                          />
                        ) : (
                          <textarea
                            name={key}
                            placeholder="Message ..."
                            value={formData[key]}
                            onChange={handleChange}
                            required
                          ></textarea>
                        )}
                      </div>
                    ))}

                    <div className="col-lg-12 col-md-12 col-sm-12 form-group centred">
                      <button
                        className="btn btn-success"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Sending Message..." : "Send Message"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>


      <div className="container my-5" aria-label="Frequently Asked Questions">
        <h2 className="mb-4">Frequently Asked Questions</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="card shadow-sm mb-2 border" key={index}>
              <div
                className="card-header d-flex justify-content-between align-items-center"
                onClick={() => toggleIndex(index)}
                style={{ cursor: 'pointer' }}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-body-${index}`}
                role="button"
              >
                <h3 className="mb-0 h6">{faq.question}</h3>
                <span style={{ fontSize: '1.2em', transition: 'transform 0.3s' }}>
                  {activeIndex === index ? '▲' : '▼'}
                </span>
              </div>
              <div id={`faq-body-${index}`} className={`collapse ${activeIndex === index ? 'show' : ''}`}>
                <div className="card-body" style={{ whiteSpace: 'pre-line' }}>
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />

      {/* Google Maps Section */}
      <section className="google-maps-section">
        <div className="auto-container mt-2 mb-4" data-aos="zoom-in">
          <div className="map-container">
            <iframe
              title="Columbiaa Hospital Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119537.43538739184!2d77.5758730442529!3d13.010418302574193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1707efe7bf55%3A0x9a2782fbc38e9c7b!2sColumbiaa%20Hospital!5e1!3m2!1sen!2sin!4v1740473493668!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contacts;
